import { Activity } from '@/types';
import {
  CustomActivity,
  filterByKeys,
  getActivityTotalCountPerWeek,
  getActivityTotalDistancePerWeek,
  getActivityTotalElevationPerWeek,
  getActivityTotalSufferScorePerWeek,
  getActivityTotalTSSPerWeek,
  getActivityTotalTimePerWeek,
  getRidingActivities,
  getRunningActivities,
  getSwimmingActivities,
  parseAllActivities,
} from './activities';
import { lastWeekNumber, maxWeeksToDisplay } from './date';
import { DataType } from './enum';

export const getTriathlonStats = (
  activities: Activity[],
  activityTotal: DataType,
  isMobile?: boolean,
  initialValue?: {
    [key: string]: number;
  }
) => {
  const getActivityTotalPerWeek = (
    activities: CustomActivity[]
  ): Record<DataType, { [x: string]: number }> => ({
    moving_time: activities.reduce(getActivityTotalTimePerWeek, {
      ...initialValue,
    }),
    distance: activities.reduce(getActivityTotalDistancePerWeek, {
      ...initialValue,
    }),
    count: activities.reduce(getActivityTotalCountPerWeek, {
      ...initialValue,
    }),
    elevation_gain: activities.reduce(getActivityTotalElevationPerWeek, {
      ...initialValue,
    }),
    suffer_score: activities.reduce(getActivityTotalSufferScorePerWeek, {
      ...initialValue,
    }),
    tss: activities.reduce(getActivityTotalTSSPerWeek, {
      ...initialValue,
    }),
  });

  const allActivities = activities.map(parseAllActivities);

  const [runningActivities, ridingActivities, swimmingActivities] = [
    getRunningActivities(allActivities),
    getRidingActivities(allActivities),
    getSwimmingActivities(allActivities),
  ];

  const [
    runningActivityTotalPerWeek,
    ridingActivityTotalPerWeek,
    swimmingActivityTotalPerWeek,
    allActivitiesTotalPerWeek,
  ] = [
    getActivityTotalPerWeek(runningActivities),
    getActivityTotalPerWeek(ridingActivities),
    getActivityTotalPerWeek(swimmingActivities),
    getActivityTotalPerWeek(allActivities),
  ];

  const limit = lastWeekNumber - maxWeeksToDisplay;

  let runningStats = runningActivityTotalPerWeek[activityTotal];
  let ridingStats = ridingActivityTotalPerWeek[activityTotal];
  let swimmingStats = swimmingActivityTotalPerWeek[activityTotal];
  const allActivitiesStats = allActivitiesTotalPerWeek[activityTotal];

  if (isMobile && lastWeekNumber > maxWeeksToDisplay) {
    [runningStats, ridingStats, swimmingStats] = [
      filterByKeys(runningStats, limit),
      filterByKeys(ridingStats, limit),
      filterByKeys(swimmingStats, limit),
    ];
  }

  return {
    runningStats,
    ridingStats,
    swimmingStats,
    allActivitiesStats,
  };
};
